import React from 'react';

export const Leyends = ({ worst, best }) => {
    return (
      <div className={'label-score'} style={{ padding: '0px 8px 0px 8px' }}>
        <div className={'description-score-worst'}>{worst}</div>
        <div className={'description-score-best'}>{best}</div>
      </div>
    );
  };